export function useCall() {

    const launchCall = async (extension, phone) => {
        try {
            const response = await fetch(`${window.runtimeConfig.API_CALL}/call/makeCall/${extension}/${phone}`);
            
            return (response.status === 200)
            
        }catch(err){
            console.error("Error al hacer la llamada:", err);
            return false;
        }
    };

    const getRecord = async (filter) => {
        try{
            let auth = window.btoa("whatsapp:whatsapp");

            var body = {userId: "whatsapp",authorization: auth,filters: filter,}

            const response = await fetch(`${window.runtimeConfig.API_CROSS}/recordList/`,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body)
                }
            );

            if (response.status === 200) {
                var json = await response.json();
                return json
            }
        }catch(err){
            console.error("Error al hacer la llamada:", err);
        }
    }

    const prepareRecord = async (callId) => {
        try{
            let check = { id: callId };

            const response = await fetch(`${window.runtimeConfig.API_CROSS}/prepareRecord/`,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(check)
                }
            );

            if (response.status === 200) {
                var json = await response.json();
                return json
            }
        }catch(err){
            console.error("Error al hacer la llamada:", err);
        }

    }

    return {launchCall, getRecord, prepareRecord};
}
